import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Manifest } from 'services/action';
import { Form } from 'ui/components';

const initialState = {
  description: '',
  nominal: 0,
};

export const FormAdditional = ({ id, onSubmit, data }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const [{ description, nominal }, setState] = React.useState(initialState);

  const $handleSubmit = async (e) => {
    const payload = {
      description,
      nominal,
    };

    if (id) {
      const req = await Dispatch(Manifest.$additional(id, payload));

      if (req?.message === 'success') {
        onSubmit();
      }
    } else {
      const req = await Dispatch(Manifest.$updateAdditional(data?.id, payload));

      if (req?.message === 'success') {
        onSubmit();
      }
    }
  };

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      description: data?.description,
      nominal: data?.nominal,
    }));
  }, [data]);

  return (
    <Form autoComplete="off">
      <div className="row">
        <div className="col-md-6">
          <Form.Input
            value={description}
            required
            onChange={(e) => {
              setState((prevState) => ({
                ...prevState,
                description: e.target.value,
              }));
            }}
            type="text"
            label="Deskripsi"
            error={StateForm?.errors?.description}
          />
        </div>
        <div className="col-md-6">
          <Form.Input
            value={nominal}
            required
            onChange={(e) => {
              setState((prevState) => ({
                ...prevState,
                nominal: e.target.valueNumber,
              }));
            }}
            type="number"
            label="Nominal"
            error={StateForm?.errors?.nominal}
          />
        </div>
      </div>

      <button
        className={
          StateForm?.loading
            ? 'btn-loading btn btn-primary px-3 w-100 mb-3'
            : 'btn btn-primary px-3 w-100 mb-3'
        }
        onClick={$handleSubmit}
        type="button"
        disabled={StateForm?.loading}
      >
        Simpan
      </button>
    </Form>
  );
};
